import { ReactNode, CSSProperties } from "react";

interface PageTransitionProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}

// No-op wrapper. Previously this rendered a framer-motion <motion.div>
// with an opacity 0→1 fade on every mount. Combined with
// AnimatePresence mode="wait" in App.tsx, that meant every navigation
// on Safari showed a ~400ms blank window (fade out → mount → data
// fetch → fade in). Removed for snap navigation; keeping the
// component as a passthrough so the 17 pages that import it keep
// working without a coordinated edit.
export const PageTransition = ({ children, className = "", style }: PageTransitionProps) => {
  return (
    <div className={className} style={style}>
      {children}
    </div>
  );
};
